"use client";

import { usePathname } from "next/navigation";

const DASHBOARD_PREFIXES = ["/mon-compte", "/espace-pro", "/admin", "/rdv/"];

// Auth routes — full-screen SaaS layout, no header/footer (like /admin, /mon-compte)
const AUTH_ROUTES = [
  "/connexion",
  "/espace-pro/connexion",
  "/inscription",
  "/mot-de-passe-oublie",
  "/mot-de-passe-reinit",
  "/verification-email",
];

function isDashboard(pathname: string): boolean {
  const withoutLocale = pathname.replace(/^\/(fr|ar|en)(?=\/|$)/, "");

  // Auth flow → hidden chrome
  if (AUTH_ROUTES.some((p) => withoutLocale === p || withoutLocale.startsWith(`${p}/`))) {
    return true;
  }

  // Exception : pages marketing publiques /espace-pro/* (landing, logiciel, démo).
  // Ces routes gardent le header pro pour la navigation cross-page. /connexion
  // est traité plus haut comme AUTH_ROUTES → header minimal de la page.
  const PUBLIC_ESPACE_PRO = [
    "/espace-pro",
    "/espace-pro/inscription",
    "/espace-pro/logiciel",
    "/espace-pro/logiciel/demo",
  ];
  if (PUBLIC_ESPACE_PRO.includes(withoutLocale)) {
    return false;
  }
  return DASHBOARD_PREFIXES.some((p) => withoutLocale.startsWith(p));
}

/**
 * Wrapper qui cache ses enfants sur les routes dashboard + auth.
 * Pattern Next.js : Client Component qui reçoit des Server Components children.
 */
export function HideOnDashboard({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (isDashboard(pathname)) return null;
  return <>{children}</>;
}

/**
 * Wrapper plus permissif pour la BottomNav mobile : on la garde visible sur
 * toutes les pages patient (y compris /mon-compte, /connexion, /rdv) pour
 * guider l'utilisateur en permanence. On la cache uniquement sur les routes
 * pro et admin qui ont leur propre navigation.
 */
const NAV_HIDE_PREFIXES = ["/espace-pro/dashboard", "/espace-pro/agenda", "/espace-pro/rendez-vous", "/espace-pro/patients", "/espace-pro/avis", "/espace-pro/stats", "/espace-pro/leads", "/espace-pro/profil", "/espace-pro/abonnement", "/espace-pro/parametres", "/admin"];

export function HideOnProAdmin({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const withoutLocale = pathname.replace(/^\/(fr|ar|en)(?=\/|$)/, "");
  if (NAV_HIDE_PREFIXES.some((p) => withoutLocale === p || withoutLocale.startsWith(`${p}/`))) return null;
  return <>{children}</>;
}
